<ion-grid class="ion-no-padding">
  <ion-row>
    <!-- [ngClass]="{'hidden-sm-down': i===1, 'hidden-lg-down': i>1}"-->
    <ion-col *ngFor="let category of (services$ | async); let i = index;" size-xs="12" size-md="12" size-lg="6" size-xl="6">

     <app-event-card [real]="real" [service]="category"></app-event-card>
    </ion-col>
 </ion-row>
</ion-grid>